import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";
import CarouselSlider from "./CarouselSlider";
import LegacySlider from "./LegacySlider";

export default ({ data }) => {
  const theme = useTheme();
  const disableGutters = useMediaQuery(theme.breakpoints.down("sm"));

  if (disableGutters) {
    return <CarouselSlider data={data} />;
  } else {
    return <LegacySlider data={data} />;
  }
};
